import messages from './cmsDiscardStagedEdit.json' with { type: 'json' };

export const cmsDiscardStagedEditEn: Readonly<typeof messages> = messages;
